export const odluka_voditelj_obrade = {
    templateId: 90.3,
    category: 9,
    templateTitle: 'Odluka o odgovornoj osobi za obradu osobnih podataka',
    templateDescription: `<p>Voditelj obrade odgovara za sve poslove obrade i usklađenost s Uredbom, no neke poslove može povjeriti i radnicima, što bi trebalo adekvatno popratiti dokumentacijom, kako radi internog praćenja, tako i radi usklađenosti s odredbama Uredbe.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Osobni podaci moraju biti obrađivani na način kojim se osigurava odgovarajuća sigurnost osobnih podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te od slučajnog gubitka, uništenja ili oštećenja primjenom odgovarajućih tehničkih ili organizacijskih mjera.</p>
    <p>Voditelj obrade odgovoran je za usklađenost s navedenim te mora biti u mogućnosti dokazati navedeno.</p>
    <p>Dolje prikazanim primjerom odluke regulira se posao obrade osobnih podataka radi dokazivanja usklađenosti s Uredbom te točnijeg i ispravnijeg uređivanja međusobnih prava i obveza voditelja obrade i imenovane osobe.</p>
    <p>Ovdje prikazanu odluku treba razlikovati od <a class="local-link" href="/contract?template=90.5">odluke o imenovanju službenika za zaštitu osobnih podataka</a> koja je obvezna u određenim slučajevima propisanim Uredbom te koja za sobom nosi dodatne obveze, kako za voditelja/izvršitelja obrade, tako i za službenika za zaštitu osobnih podataka.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Opće uredbe o zaštiti podataka,',
            signature: 'Za Voditelja obrade:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Voditelj obrade),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O OSOBAMA ODGOVORNIM ZA OBRADU OSOBNIH PODATAKA',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Kod poslodavca se obavlja obrada nekih/svih od ispod navedenih osobnih podataka:\r\n',
                    value: '',
                },
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: '- ime i prezime,\r\n- adresu, \r\n- osobni identifikacijski broj i/ili drugi identifikacijski broj,\r\n- datum rođenja / JMBG, \r\n- osobni broj iz e-radne knjižice,\r\n- broj tekućeg ili žiro-računa,\r\n- dokaz o završenom školovanju (svjedodžba, diploma i sl.), \r\n- uvjerenje o zdravstvenoj sposobnosti i sl.,\r\npreduvjet za sklapanje i izvršenje Ugovora o radu odnosno svih obveza iz radnog odnosa te je navedene podatke u tom smislu Radnik pružio Poslodavcu. ',
                    help: 'Ovdje unosite kategorije osobnih podataka koje obrađuje voditelj obrade. Prethodno uneseno je samo dano radi primjera.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: "",
            mandatory: true,
            type: "input",
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                            { type: "text", content: "Radnik" },
                            { type: 'input', value: '', required: true, placeholder: "Ime i prezime", },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz' },
                        { type: 'input', value: '', required: true,placeholder: "Mjesto", },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj", },
                        {type: 'text', content: ','},
                        { type: 'text', content: 'OIB:' },
                        { type: "input",  required: true,},
                        {type: 'text', content: ', zaposlen na radnom mjestu'},
                        {type: 'input', value: '', required: true},
                            { type: "text", content: "imenuje se odgovornom osobom za obradu sljedećih osobnih podataka:" },
                            { type: "textarea", value: "", required: true },
                        ]
                      },
                {
                    parts: [

                        { type: "text", content: "Osobama odgovornim za obradu osobnih podataka imenuje se sljedeće osobe te se određuju sljedeći osobni podaci koje će obrađivati:" },
                        { type: "textarea", value: "", required: true },
                    ]
                  },
                ],
              }
            ]
          },
          {
            title: "",
            mandatory: false,
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: true,
                choices: [
                  "Imenovana osoba iz ove Odluke obavlja poslove obrade i prikupljanja osobnih podataka, poslove vezane uz upisivanja podataka u evidenciju aktivnosti te druge poslove vezane uz obradu osobnih podataka propisane Općom uredbom o zaštiti podataka.",
                  "Imenovane osobe iz ove Odluke obavljaju poslove obrade i prikupljanja osobnih podataka, poslove vezane uz upisivanja podataka u evidenciju aktivnosti te druge poslove vezane uz obradu osobnih podataka propisane Općom uredbom o zaštiti podataka.",
                ],
                placeholder: "Odaberite ovdje te potom izmijenite po želji...",
              },
            ]
          },
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Ova Odluka se primjenjuje od dana" }, 
                    { type: "input", value: "", required: true },
                    { type: "text", content: "godine, sve do opoziva."}, 
                ],
              }
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Voditelju obrade \r\n2) Arhiva',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};





// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/90.3_odluka_vod_obrade.ts